// Imports
import { urlFVinculacion } from "../../constants/urls";
import {FetchPost} from './api';
import { createAction } from "redux-actions";


// ------------------------- Inician Acciones -------------------------

export const consultarUsuarioFvLoading = createAction("CONSULTAR_USUARIO_FV_LOADING");
export const consultarUsuarioFvHasErrror = createAction("CONSULTAR_USUARIO_FV_HAS_ERROR");
export const setConsultarUsuarioFv = createAction("SET_CONSULTAR_USUARIO_FV");

// ------------------------- Terminan Acciones -------------------------




//------------------------- Inician Funciones que utilizan acciones -------------------------

// Consultar el FV del usuario
export const consultarUsuarioFV = (param) => async (dispatch) => {
  // url
  const url = urlFVinculacion + param.id;
  
  console.log('consultarFViNTERNO' , param, url);

  // loading
  dispatch(consultarUsuarioFvLoading());

  // llamar servicio
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param.content),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('data_es', data);
      if (data.transaccion) {
        dispatch(setConsultarUsuarioFv(data));
      } else {
        dispatch(consultarUsuarioFvHasErrror())
      }
    })
    .catch(() => {
      dispatch(consultarUsuarioFvHasErrror())
    });
};

//------------------------- Terminan Funciones que utilizan acciones -------------------------